/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetWithdrawalFeeQuoteOptions,
  GetWithdrawalFeeQuoteStatus200,
  GetWithdrawalFeeQuoteStatus400,
  GetWithdrawalFeeQuoteStatus401,
  GetWithdrawalFeeQuoteStatus403,
  GetWithdrawalFeeQuoteStatus404,
  GetWithdrawalFeeQuoteStatus409,
  GetWithdrawalFeeQuoteStatus429,
  GetWithdrawalFeeQuoteStatus500,
  GetWithdrawalFeeQuoteStatus502,
  GetWithdrawalFeeQuoteStatus503,
} from '../types/GetWithdrawalFeeQuote'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getWithdrawalFeeQuote } from '../clients/getWithdrawalFeeQuote'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getWithdrawalFeeQuoteQueryKey = ({
  query,
}: Omit<GetWithdrawalFeeQuoteOptions, 'headers'>) =>
  [{ url: '/v1/web3/withdrawals/fee-quote' }, ...(query ? [query] : [])] as const

type GetWithdrawalFeeQuoteQueryKey = ReturnType<typeof getWithdrawalFeeQuoteQueryKey>

export function getWithdrawalFeeQuoteQueryOptions(
  { query }: GetWithdrawalFeeQuoteOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getWithdrawalFeeQuoteQueryKey({ query })
  return queryOptions<
    GetWithdrawalFeeQuoteStatus200,
    ResponseErrorConfig<
      | GetWithdrawalFeeQuoteStatus400
      | GetWithdrawalFeeQuoteStatus401
      | GetWithdrawalFeeQuoteStatus403
      | GetWithdrawalFeeQuoteStatus404
      | GetWithdrawalFeeQuoteStatus409
      | GetWithdrawalFeeQuoteStatus429
      | GetWithdrawalFeeQuoteStatus500
      | GetWithdrawalFeeQuoteStatus502
      | GetWithdrawalFeeQuoteStatus503
    >,
    GetWithdrawalFeeQuoteStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getWithdrawalFeeQuote({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Estimates the network fee for an existing, admin-approved (APPROVED_WITHOUT_FEE) withdrawal owned by the caller. Redeem the returned quote token at PUT /v1/web3/withdrawals/{withdrawal_id} to reserve the fee. Restricted to USDC native-asset users.
 * @summary Estimate the network fee to withdraw USDC via web3
 * {@link /v1/web3/withdrawals/fee-quote}
 */
export function useGetWithdrawalFeeQuote<
  TData = GetWithdrawalFeeQuoteStatus200,
  TQueryData = GetWithdrawalFeeQuoteStatus200,
  TQueryKey extends QueryKey = GetWithdrawalFeeQuoteQueryKey,
>(
  {
    query,
  }: {
    query: GetWithdrawalFeeQuoteOptions['query'] | (() => GetWithdrawalFeeQuoteOptions['query'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetWithdrawalFeeQuoteStatus200,
        ResponseErrorConfig<
          | GetWithdrawalFeeQuoteStatus400
          | GetWithdrawalFeeQuoteStatus401
          | GetWithdrawalFeeQuoteStatus403
          | GetWithdrawalFeeQuoteStatus404
          | GetWithdrawalFeeQuoteStatus409
          | GetWithdrawalFeeQuoteStatus429
          | GetWithdrawalFeeQuoteStatus500
          | GetWithdrawalFeeQuoteStatus502
          | GetWithdrawalFeeQuoteStatus503
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getWithdrawalFeeQuoteQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getWithdrawalFeeQuoteQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetWithdrawalFeeQuoteStatus400
      | GetWithdrawalFeeQuoteStatus401
      | GetWithdrawalFeeQuoteStatus403
      | GetWithdrawalFeeQuoteStatus404
      | GetWithdrawalFeeQuoteStatus409
      | GetWithdrawalFeeQuoteStatus429
      | GetWithdrawalFeeQuoteStatus500
      | GetWithdrawalFeeQuoteStatus502
      | GetWithdrawalFeeQuoteStatus503
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
